(function ($) {
  "use strict";

  //Hide Loading Box (Preloader)
  function handlePreloader() {
    if ($(".preloader").length) {
      $(".preloader").delay(200).fadeOut(500);
    }
  }

  //Update Header Style and Scroll to Top
  function headerStyle() {
    if ($(".main-header").length) {
      var windowpos = $(window).scrollTop();
      var siteHeader = $(".main-header");
      var scrollLink = $(".scroll-top");
      if (windowpos >= 110) {
        siteHeader.addClass("fixed-header");
        scrollLink.addClass("open");
      } else {
        siteHeader.removeClass("fixed-header");
        scrollLink.removeClass("open");
      }
    }
  }

  headerStyle();

  //Submenu Dropdown Toggle
  if ($(".main-header li.dropdown ul").length) {
    $(".main-header .navigation li.dropdown").append(
      '<div class="dropdown-btn"><span class="fa fa-angle-right"></span></div>'
    );
  }

  //Mobile Nav Hide Show
  if ($(".mobile-menu").length) {
    $(".mobile-menu .menu-box").mCustomScrollbar();

    var mobileMenuContent = $(".main-header .menu-area .main-menu").html();
    $(".mobile-menu .menu-box .menu-outer").append(mobileMenuContent);
    $(".sticky-header .main-menu").append(mobileMenuContent);

    //Dropdown Button
    $(".mobile-menu li.dropdown .dropdown-btn").on("click", function () {
      $(this).toggleClass("open");
      $(this).prev("ul").slideToggle(500);
    });
    //Menu Toggle Btn
    $(".mobile-nav-toggler").on("click", function () {
      $("body").addClass("mobile-menu-visible");
    });

    //Menu Toggle Btn
    $(".mobile-menu .menu-backdrop,.mobile-menu .close-btn").on(
      "click",
      function () {
        $("body").removeClass("mobile-menu-visible");
      }
    );
  }

  // Scroll to a Specific Div
  if ($(".scroll-to-target").length) {
    $(".scroll-to-target").on("click", function () {
      var target = $(this).attr("data-target");
      // animate
      $("html, body").animate(
        {
          scrollTop: $(target).offset().top,
        },
        1000
      );
    });
  }

  // Elements Animation
  if ($(".wow").length) {
    var wow = new WOW({
      mobile: false,
    });
    wow.init();
  }


  //Fact Counter + Text Count
  if ($(".count-box").length) {
    $(".count-box").appear(
      function () {
        var $t = $(this),
          n = $t.find(".count-text").attr("data-stop"),
          r = parseInt($t.find(".count-text").attr("data-speed"), 10);

        if (!$t.hasClass("counted")) {
          $t.addClass("counted");
          $({
            countNum: $t.find(".count-text").text(),
          }).animate(
            {
              countNum: n,
            },
            {
              duration: r,
              easing: "linear",
              step: function () {
                $t.find(".count-text").text(Math.floor(this.countNum));
              },
              complete: function () {
                $t.find(".count-text").text(this.countNum);
              },
            }
          );
        }
      },
      { accY: 0 }
    );
  }

  //LightBox / Fancybox
  if ($(".lightbox-image").length) {
    $(".lightbox-image").fancybox({
      openEffect: "fade",
      closeEffect: "fade",
      helpers: {
        media: {},
      },
    });
  }

  //Tabs Box
  if ($(".tabs-box").length) {
    $(".tabs-box .tab-buttons .tab-btn").on("click", function (e) {
      e.preventDefault();
      var target = $($(this).attr("data-tab"));

      if ($(target).is(":visible")) {
        return false;
      } else {
        target
          .parents(".tabs-box")
          .find(".tab-buttons")
          .find(".tab-btn")
          .removeClass("active-btn");
        $(this).addClass("active-btn");
        target
          .parents(".tabs-box")
          .find(".tabs-content")
          .find(".tab")
          .fadeOut(0);
        target
          .parents(".tabs-box")
          .find(".tabs-content")
          .find(".tab")
          .removeClass("active-tab");
        $(target).fadeIn(300);
        $(target).addClass("active-tab");
      }
    });
  }


  // clients-carousel
  if ($(".clients-carousel").length) {
    console.log("clients-carousel элемент найден");
    $(".clients-carousel").owlCarousel({
      loop: false,
      margin: 30,
      nav: false,
      smartSpeed: 3000,
      autoplay: false,
      navText: [
        '<span class="flaticon-left"></span>',
        '<span class="flaticon-right"></span>',
      ],
      responsive: {
        0: {
          items: 1,
        },
        480: {

          items: 2,
        },
        600: {
          items: 3,
        },
        800: {
          items: 4,
        },
        1200: {
          items: 5,
        },
      },
    });
  }

  // testimonial-carousel
  if ($(".testimonial-carousel").length) {
    $(".testimonial-carousel").owlCarousel({
      loop: false,
      margin: 30,
      nav: false,
      smartSpeed: 3000,
      autoplay: false,
      navText: [
        '<span class="flaticon-left"></span>',
        '<span class="flaticon-right"></span>',
      ],
      responsive: {
        0: {
          items: 1,
        },
        480: {
          items: 1,
        },
        600: {
          items: 1,
        },
        800: {
          items: 1,
        },
        1200: {
          items: 1,
        },
      },
    });
  }

  //Main Slider Carousel
  if ($(".main-slider-carousel").length) {
    console.log("main slider widno");
    $(".main-slider-carousel").owlCarousel({
      loop: false,
      margin: 0,
      nav: false,
      animateOut: "fadeOut",
      animateIn: "fadeIn",
      active: true,
      smartSpeed: 1000,
      autoplay: false,
      navText: [
        '<span class="flaticon-back"></span>',
        '<span class="flaticon-right"></span>',
      ],
      responsive: {
        0: {
          items: 1,
        },
        600: {
          items: 1,
        },
        1200: {
          items: 1,
        },
      },
    });
  }

  //three-column-carousel
  // if ($(".three-column-carousel").length) {
  //   $(".three-column-carousel").owlCarousel({
  //     loop: false,
  //     margin: 30,
  //     nav: false,
  //     smartSpeed: 3000,
  //     autoplay: false,
  //     navText: [
  //       '<span class="flaticon-back"></span>',
  //       '<span class="flaticon-right"></span>',
  //     ],
  //     responsive: {
  //       0: {
  //         items: 1,
  //       },
  //       480: {
  //         items: 1,
  //       },
  //       600: {
  //         items: 2,
  //       },
  //       800: {
  //         items: 2,
  //       },
  //       1024: {
  //         items: 3,
  //       },
  //     },
  //   });
  // }

  //Client Testimonial Carousel
  if (
    $(".client-testimonial-carousel").length &&
    $(".client-thumbs-carousel").length
  ) {
    var $sync3 = $(".client-testimonial-carousel"),
      $sync4 = $(".client-thumbs-carousel"),
      flag = false,
      duration = 500;

    $sync3
      .owlCarousel({
        loop: false,
        items: 1,
        margin: 0,
        nav: true,
        navText: [
          '<span class="flaticon-back"></span>',
          '<span class="flaticon-right"></span>',
        ],
        dots: false,
        autoplay: true,
        autoplayTimeout: 5000,
      })
      .on("changed.owl.carousel", function (e) {
        if (!flag) {
          flag = false;
          $sync4.trigger("to.owl.carousel", [e.item.index, duration, true]);
          flag = false;
        }
      });

    $sync4
      .owlCarousel({
        loop: false,
        margin: 20,
        items: 1,
        nav: false,
        navText: [
          '<span class="flaticon-back"></span>',
          '<span class="flaticon-right"></span>',
        ],
        dots: true,
        center: false,
        autoplay: false,
        autoplayTimeout: 5000,
        responsive: {
          0: {
            items: 1,
            autoWidth: false,
          },
          400: {
            items: 1,
            autoWidth: false,
          },
          600: {
            items: 1,
            autoWidth: false,
          },
          1000: {
            items: 1,
            autoWidth: false,
          },
          1200: {
            items: 1,
            autoWidth: false,
          },
        },
      })

      .on("click", ".owl-item", function () {
        $sync3.trigger("to.owl.carousel", [$(this).index(), duration, true]);
      })
      .on("changed.owl.carousel", function (e) {
        if (!flag) {
          flag = true;
          $sync3.trigger("to.owl.carousel", [e.item.index, duration, true]);
          flag = false;
        }
      });
  }

  // Four Item Carousel
  if ($(".four-item-carousel").length) {
    $(".four-item-carousel").owlCarousel({
      loop: false,
      margin: 30,
      nav: true,
      autoHeight: true,
      smartSpeed: 500,
      autoplay: false,
      navText: [
        '<span class="fas fa-angle-left"></span>',
        '<span class="fas fa-angle-right"></span>',
      ],
      responsive: {
        0: {
          items: 1,
        },
        600: {
          items: 2,
        },
        800: {
          items: 3,
        },
        1024: {
          items: 3,
        },
        1200: {
          items: 4,
        },
      },
    });
  }

  // Select menu
  function selectDropdown() {
    if ($(".selectmenu").length) {
      $(".selectmenu").selectmenu();

      var changeSelectMenu = function (event, item) {
        $(this).trigger("change", item);
      };
      $(".selectmenu").selectmenu({ change: changeSelectMenu });
    }
  }

  //Price Range Slider
  if ($(".price-range-slider").length) {
    $(".price-range-slider").slider({
      range: true,
      min: 45,
      max: 250,
      values: [0, 250],
      slide: function (event, ui) {
        $("input.property-amount").val(ui.values[0] + " - " + ui.values[1]);
      },
    });

    $("input.property-amount").val(
      $(".price-range-slider").slider("values", 0) +
      " - $" +
      $(".price-range-slider").slider("values", 1)
    );
  }

  //Jquery Spinner / Quantity Spinner

  /*	=========================================================================
  When document is Scrollig, do
  ========================================================================== */

  jQuery(document).on("ready", function () {
    (function ($) {
      // add your functions
      selectDropdown();
    })(jQuery);
  });

  /* ==========================================================================
   When document is Scrollig, do
   ========================================================================== */

  $(window).on("scroll", function () {
    headerStyle();
  });

  /* ==========================================================================
   When document is loaded, do
   ========================================================================== */

  $(window).on("load", function () {
    handlePreloader();
  });
})(window.jQuery);
